import styled from 'particles/themes/styled'
import { theme } from 'theme'
import i18n from 'config/i18n'
import Text from 'particles/Text'

export const EditRequestHistoryText = styled(Text)`
    &:hover:not([disabled]) {
        cursor: pointer;
    }
`
export const ModalContentContainer = styled.div`
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    .title {
        color: ${theme.colors.governorBay};
        font-size: ${theme.newFontSizes.xl};
        text-align: center;
        margin: 0;
        min-width: 0;
        box-sizing: border-box;
    }
    .profile {
        margin-bottom: 10px;
    }
    .show-btn {
        align-self: center;
        width: fit-content;
    }
    .empty-container {
        display: flex;
        flex-direction: column;
        padding: 16px 0px;
        gap: ${({ theme }) => theme.spacing[300]};
        align-self: center;
        align-items: center;
    }
`

export const CustomSubmissionContentContainer = styled.div`
    margin-top: ${theme.newSpacing.s};
    text-align: left;
`

export const MediaBtnContainer = styled.div`
    padding: ${theme.newSpacing.s};
    margin-top: ${theme.newSpacing.s};
    margin-left: auto;
    margin-right: auto;
`

interface CaptionTextProps {
    showFullText: boolean
}
export const CaptionContainer = styled(Text)<CaptionTextProps>`
    display: -webkit-box;
    ${(props: CaptionTextProps) => (props.showFullText ? { WebkitLineClamp: 'unset' } : { WebkitLineClamp: 1 })}
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
    margin-top: 12px;
    margin-bottom: 12px;
`
export const TimeContainer = styled.div`
    font-size: ${theme.newFontSizes.xxs};
    margin-top: ${theme.newSpacing.xxs};
    color: ${theme.colors.doveGrey};
`

export const ToggleCaptionContainer = styled.div`
    margin-top: ${theme.newSpacing.s};
    margin-bottom: ${theme.newSpacing.s};
    input[type='checkbox'] {
        display: none;
    }
    label {
        color: ${theme.colors.astronaut};
        cursor: pointer;
        display: inline-block;
        font-size: ${theme.newFontSizes.xs};
    }
    label:after {
        content: '${i18n.t('button.readMore').toString()}';
    }

    input:checked ~ label:after {
        content: '${i18n.t('button.readLess').toString()}';
    }

    input:checked + .inner {
        -webkit-line-clamp: unset;
    }

    .inner {
        display: -webkit-box;
        font-size: ${theme.newFontSizes.xs};
        -webkit-line-clamp: 1;
        -webkit-box-orient: vertical;
        overflow: hidden;
        text-overflow: ellipsis;
    }
`

export const UrlContainer = styled.div`
    margin-top: ${theme.newSpacing.s};
    margin-bottom: ${theme.newSpacing.s};
    font-size: ${theme.newFontSizes.xs};
`

export const BlockTitleContainer = styled.div`
    font-size: ${theme.newFontSizes.s};
    font-weight: bold;
    margin-top: ${theme.newSpacing.m};
    margin-bottom: ${theme.newSpacing.xxs};
`
